let IslandsManager = require("./IslandsManager")

const Status = {
    Unload: 0,
    Loading: 1,
    Loaded: 2,
    Destroy: 3,
};

let IslandItemNode = xClass("IslandItemNode2", cc.Node)

const IslandSize = { width: 541, height: 452 }//{ width: 541, height: 452 } 
const AniScale = IslandSize.width / 720
const AniPosition = { x: 250, y: 330}

IslandItemNode.prototype.ctor = function(islandInfo, onClick) {
    cc.Node.prototype.ctor.call(this);
    this.islandInfo = islandInfo;
    this.spIsland = null;
    this.spName = null;
    this.lbLevel = null;   
    this.anim = null;

    this.status = Status.Unload;
    
    this.setContentSize(IslandSize.width, IslandSize.height);
    this.setAnchorPoint(0.5, 1);
    this.setPosition(0, 0);
    
    if (this.islandInfo != null && onClick != null) {
        UIButton.create(this);
        this.hitTestPrior = true;
        this.on(UIButtonEvent.Click, onClick);
    }

    this.resReleased = false;
}

IslandItemNode.prototype.show = function() {  
    this.setVisible(true);
}

IslandItemNode.prototype.hide = function(clear) { 
    this.setVisible(false);
    if (clear && this.status == Status.Loaded) {
        this.clearAll();
        this.status = Status.Unload;
    }
}

IslandItemNode.prototype.drawItem = function() {
    const centerX = IslandSize.width * 0.5;

    let res = IslandsManager.getInstance().getIslandRes(this.islandInfo);
    let resList = res.resList;

    if (res.hasOwnProperty("island")) {
        this.spIsland = new cc.Sprite.create(res.island);
        this.spIsland.setAnchorPoint(0.5, 0);
        this.spIsland.setPosition(centerX, 0);
        this.addChild(this.spIsland);
    }

    if (res.hasOwnProperty("animClass")) {
        this.anim = res["animClass"].create();
        this.anim.setScale(AniScale);
        this.anim.setPosition(AniPosition.x, AniPosition.y);
        this.spIsland.addChild(this.anim);
    }

    if (res.hasOwnProperty("name")) {
        this.spName = new cc.Sprite.create(res.name);
        this.spName.setAnchorPoint(0.5, 0);
        this.spName.setPosition(centerX - 20, IslandSize.height - 20);
        this.addChild(this.spName);
    }

    if (res.hasOwnProperty("fnt")) {
        this.lbLevel = cc.Label.createWithBMFont(res.fnt, res.text);
        this.lbLevel.setAnchorPoint(0.5, 0);
        this.lbLevel.setPosition(centerX, 220);
        this.addChild(this.lbLevel);
    }
}

IslandItemNode.prototype.load = function(onComplete) {
    if (this.status != Status.Unload) {
        onComplete();
        return;
    }

    this.status = Status.Loading;

    let res = IslandsManager.getInstance().getIslandRes(this.islandInfo);
    preloadWithLoading(res.resList, 
        ()=> {
            if (this.status == Status.Loading) {
                this.drawItem();
                this.status = Status.Loaded;
            }
            onComplete();
        }, 
        ()=> {
            if (this.status == Status.Loading) {
                console.warn(`island ${islandItemNode.islandInfo.id} load res failed.`)
                islandItemNode.status = Status.Unload;
            } 
            onComplete();
        }, 
    null, false);
}

IslandItemNode.prototype.clearAll = function() {
    this.removeAllChildren();
    
    this.spIsland = null;
    this.spName = null;
    this.lbLevel = null;   
    this.anim = null;
    
    let res = IslandsManager.getInstance().getIslandRes(this.islandInfo);
    ResManager.release(res.resList);
}

IslandItemNode.prototype.onCleanup = function() {
    if (this.status == Status.Loaded) {
        this.clearAll();
        this.status = Status.Destroy
    }
    this.islandInfo = null;
}

IslandItemNode.ContentSize = IslandSize
IslandItemNode.AniScale = AniScale
IslandItemNode.AniPosition = AniPosition
module.exports = IslandItemNode